import { defaultStore, stores } from '../../translations'

/**
 * Подключаем ассеты for me в игре doodle только на RU store
 * Дата окончания действия ассетов не установлена
 * */
export const isJumperForMeAssets = (store = defaultStore) => {
  const isForMeGameActive = false

  return isForMeGameActive && store === stores.ru
}
